import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    APPROVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    PENDING: "bg-amber-50 text-amber-700 border-amber-200",
    REJECTED: "bg-red-50 text-red-700 border-red-200",
    SUSPENDED: "bg-slate-100 text-slate-600 border-slate-200",
    PAID: "bg-emerald-50 text-emerald-700 border-emerald-200",
    CANCELLED: "bg-red-50 text-red-700 border-red-200",
    EXPIRED: "bg-slate-100 text-slate-600 border-slate-200",
    PUBLISHED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    DRAFT: "bg-amber-50 text-amber-700 border-amber-200",
    ARCHIVED: "bg-slate-100 text-slate-600 border-slate-200",
  };
  const label = {
    APPROVED: "Disetujui", PENDING: "Menunggu", REJECTED: "Ditolak", SUSPENDED: "Nonaktif",
    PAID: "Lunas", CANCELLED: "Dibatalkan", EXPIRED: "Kedaluwarsa",
    PUBLISHED: "Terbit", DRAFT: "Draft", ARCHIVED: "Arsip",
  };
  return (
    <span className={`inline-flex text-[11px] font-semibold px-2 py-0.5 rounded-full border ${map[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {label[status] || status}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="text-center py-16" data-testid="empty-state">
      {Icon && <span className="grid place-items-center h-14 w-14 rounded-full bg-slate-100 text-slate-400 mx-auto mb-4"><Icon className="h-7 w-7" /></span>}
      <h3 className="font-heading font-semibold text-slate-900 mb-1">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
    </div>
  );
}
